var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      class: {
        "setting-cell": true,
        "compare-base-value":
          _vm.setting.compare_base &&
          _vm.setting["Value"] !== _vm.setting.compare_base["Value"]
      }
    },
    [
      _c("span", { staticClass: "setting-name" }, [
        _vm._v(_vm._s(_vm.setting_name))
      ]),
      _vm._v(" "),
      typeof _vm.setting_value === "number"
        ? _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.setting_value,
                  expression: "setting_value"
                }
              ],
              staticClass: "setting-input-number",
              attrs: { type: "number" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.setting_value = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            _vm._l(_vm.valid_numbers, function(num) {
              return _c(
                "option",
                {
                  key: num,
                  class: {
                    "compare-base-value":
                      _vm.setting.compare_base &&
                      num === _vm.setting.compare_base["Value"]
                  }
                },
                [_vm._v(_vm._s(num))]
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      typeof _vm.setting_value === "boolean"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.setting_value,
                expression: "setting_value"
              }
            ],
            staticClass: "setting-input-bool",
            attrs: { type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.setting_value)
                ? _vm._i(_vm.setting_value, null) > -1
                : _vm.setting_value
            },
            on: {
              change: function($event) {
                var $$a = _vm.setting_value,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.setting_value = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.setting_value = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.setting_value = $$c
                }
              }
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-483def47", { render: render, staticRenderFns: staticRenderFns })
  }
}